import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';
const ToolbarUnindentIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={32}
        height={32}
        viewBox="0 0 32 32"
        className="Icon toolbar-unindent"
        {...props}
    >
        <g fill="none" fillRule="evenodd">
            <rect width={32} height={32} fill="#EBEDEE" rx={4} />
            <path
                fill="#48505E"
                d="M15.25 20.25a.75.75 0 0 0-.102 1.493l.102.007h8a.75.75 0 0 0 .102-1.493l-.102-.007h-8zm-4.47-7.28a.749.749 0 0 0-1.06 0l-2.5 2.5a.749.749 0 0 0 0 1.06l2.5 2.5a.749.749 0 1 0 1.06-1.06L8.81 16l1.97-1.97a.749.749 0 0 0 0-1.06zm4.47 2.28a.75.75 0 0 0-.102 1.493l.102.007h8a.75.75 0 0 0 .102-1.493l-.102-.007h-8zm0-5a.75.75 0 0 0-.102 1.493l.102.007h8a.75.75 0 0 0 .102-1.493l-.102-.007h-8z"
            />
        </g>
    </svg>
);
const Memo = memo(ToolbarUnindentIcon);
export default Memo;
